



















const ModelEvents = {
  MODEL_STATUS: 'ix_model_status',
  MODEL_ERROR: 'ix:error_training_model'
};

const SuggestionEvents = {
  ACCEPT_SUGGESTION_SUCCESS: 'ACCEPT_SUGGESTION_SUCCESS',
  ACCEPT_SUGGESTION_ERROR: 'ACCEPT_SUGGESTION_ERROR'
};

export { ModelEvents, SuggestionEvents };